export const CAMPOS_UBICACION = ['PROVINCIA', 'MUNICIPIO', 'BARRIO', 'SUBBARRIO'];
export const normalizarUbicacion = (contenido) => {
  const fields = { ...(contenido?.fields || {}) };
  const direccion = [fields['EMP-05.CALLE'], fields['EMP-05.NUMERO']]
    .filter(value => value != null && String(value).trim()).map(value => String(value).trim()).join(', ');
  return { ...(contenido || {}), fields: { ...fields, 'EMP-05.PAIS': 'DO', 'EMP-05.CALLE': direccion, 'EMP-05.NUMERO': '' } };
};

const normalizarNombre = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
export const resolverUbicacion = (opciones, valor) => {
  if (valor == null || valor === '') return '';
  const porId = opciones.find(item => String(item.Id) === String(valor));
  if (porId) return String(porId.Id);
  const coincidencias = opciones.filter(item => normalizarNombre(item.Nombre) === normalizarNombre(valor));
  return coincidencias.length === 1 ? String(coincidencias[0].Id) : '';
};

export const cambiarUbicacion = (contenido, campo, valor) => {
  const fields = { ...(contenido?.fields || {}), [`EMP-05.${campo}`]: valor };
  const indice = CAMPOS_UBICACION.indexOf(campo);
  if (indice >= 0) CAMPOS_UBICACION.slice(indice + 1).forEach(hijo => { fields[`EMP-05.${hijo}`] = ''; });
  return { ...(contenido || {}), fields };
};
